import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";

interface ProjectSchedulesDeleteSelectedButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export const ProjectSchedulesDeleteSelectedButton = ({
  disabled,
  onClick,
}: ProjectSchedulesDeleteSelectedButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button disabled={disabled} variant="outline" size="sm" onClick={onClick}>
      <Trash2 className="w-4 h-4 mr-2" />
      {t("projectSchedules.buttons.deleteSelectedSchedules")}
    </Button>
  );
};
